import React, { useState, useEffect } from "react";

function About(props) {
	useEffect(() => {
		if (props.darkMode) {
			document.body.classList.add("dark-mode");
		} else {
			document.body.classList.remove("dark-mode");
		}
	}, [props.darkMode]);

	useEffect(() => {
		if (props.darkMode) {
			props.setTextColor("#ffffff"); // Set text color to white for dark mode
			props.setBackgroundColor("#333333"); // Set background color to black for dark mode
		} else {
			props.setTextColor("#000000"); // Set text color to black for light mode
			props.setBackgroundColor("#ffffff"); // Set background color to white for light mode
		}
	}, [props.darkMode]);

	return (
		<>
			<div>
				<br></br>
				<br></br>
				<br></br>
				<h1 style={{ color: "violet" }}>𝔸𝕓𝕠𝕦𝕥 𝕄𝕖</h1>
				<p>
					Welcome to TextUtils Website . An Open Source Project . I am the owner
					of this site...
				</p>
				<p>======================================</p>
				<h2 style={{ color: "violet", fontFamily: "cursive" }}>
					Rahul Chowdhury
				</h2>
				<p style={{ fontFamily: "cursive" }}>Checkout my More Project :🔗</p>
				<a
					href="https://www.linkedin.com/in/rahul-chowdhury-45b61828b/"
					target="_blank"
					rel="noopener noreferrer"
				>
					Linkedin :
				</a>
				<p>https://www.linkedin.com/in/rahul-chowdhury-45b61828b/</p>
				<a
					href="mailto:chowdhuryrahul865@gmail.com?subject = Feedback&body = Message"
					target="_blank"
					rel="noopener noreferrer"
				>
					Gmail (Feedback) :
				</a>
				<p>chowdhuryrahul865@gmail.com</p>
				<a
					href="https://github.com/Rahul-2314"
					target="_blank"
					rel="noopener noreferrer"
				>
					Github :
				</a>
				<p>https://github.com/Rahul-2314</p>
			</div>
		</>
	);
}

export default About;
